import axios from "axios";
import { BASE_URL } from "../../../configs/WebServiceUrl";
import { apiKeyHeader } from "../../../configs/ApiKeys";

// const API_BASE_URL = "http://localhost:3001/api"; // Update with your actual API URL
// export const API_BASE_URL  = "https://web1024.docmaster.in:5010/api";

const api = axios.create({
  baseURL: BASE_URL + "/api",
});

// // Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      ...apiKeyHeader(), 
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// // Response interceptor to handle errors
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
